export default __webpack_public_path__ + "static/media/degres-green.465b2d51.svg";